import { BED_COUNTS } from "../constants";

export function findBedCountByLabel(value: string) {
    const foundValue = BED_COUNTS.find((bedCount) => {
        return bedCount.label === value
    })

    return foundValue?.value
}